import Vue from 'vue'
import Router from 'vue-router'
import {
  guardByHome,
  // guardByAuth,
  handleSignOut,
  handleFederatedSignIn,
  handleIdpresponse
} from '@/middleware/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/pages/home/index.vue'),
      beforeEnter: guardByHome
    },
    {
      path: '/:provider',
      name: 'provider-index',
      component: () => import('@/pages/home/index.vue'),
      beforeEnter: guardByHome
    },
    {
      path: '/auth/federated-sign-in',
      name: 'federatedSignIn',
      beforeEnter: handleFederatedSignIn
    },
    {
      path: '/auth/sign-out',
      name: 'authSigniOut',
      beforeEnter: handleSignOut
    },
    {
      path: '/auth/idpresponse',
      name: 'authIdpresponse',
      beforeEnter: handleIdpresponse
    },
    {
      path: '/auth',
      component: () => import('@/pages/auth.vue'),
      redirect: () => {
        return '/auth/sign-in'
      },
      children: [
        {
          path: '/auth/sign-in',
          name: 'authSigniIn',
          component: () => import('@/pages/auth/sign-in.vue')
        }
      ]
    }
  ]
})

export default router
